import { useEffect, useMemo, useRef } from "react";

const uid = () => Math.random().toString(36).slice(2, 10) + Date.now().toString(36);

/** Query params passed by the WordPress shortcode + iframe auto-height via postMessage. */
export function useEmbedFrame() {
  const params = useMemo(() => {
    const p = new URLSearchParams(window.location.search);
    return {
      exam: p.get("exam") || "",
      post_id: p.get("post_id") || "",
      page_url: p.get("page_url") || (document.referrer || ""),
      page_title: p.get("page_title") || "",
      utm_source: p.get("utm_source") || "",
      utm_medium: p.get("utm_medium") || "",
      utm_campaign: p.get("utm_campaign") || "",
      cta: p.get("cta") || "",
      compact: p.get("compact") === "1",
    };
  }, []);

  const sessionId = useMemo(() => {
    const k = "ez_widget_session";
    let v = sessionStorage.getItem(k);
    if (!v) { v = uid(); sessionStorage.setItem(k, v); }
    return v;
  }, []);

  const rootRef = useRef(null);
  useEffect(() => {
    document.body.style.background = "transparent";
    const post = () => {
      const h = rootRef.current ? rootRef.current.getBoundingClientRect().height : document.body.scrollHeight;
      if (window.parent !== window) window.parent.postMessage({ type: "ez-subscribe:height", height: Math.ceil(h) + 8 }, "*");
    };
    post();
    const ro = new ResizeObserver(post);
    if (rootRef.current) ro.observe(rootRef.current);
    return () => ro.disconnect();
  }, []);

  const inIframe = window.parent !== window;
  return { params, sessionId, rootRef, inIframe };
}
